<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="row">
      <div class="col-md-12 mb-4" align="right">
        <base-button type="danger" class="pl-4 pr-4" @click="onDeleteClicked()"
          >Delete</base-button
        >
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 mb-4" v-if="post">
        <div class="card">
          <video-player
            :options="playerOptions"
            :src="videoSource"
            v-if="video"
          />
          <img
            :src="post.image"
            class="img-fluid"
            alt="Responsive image"
            v-if="!video"
          />
          <div class="ml-4 mr-4 mt-4 mb-4">
            <h4 class="pt-3 pb-3">{{ post.content }}</h4>
            <div class="media align-items-center">
              <span class="avatar avatar-lg rounded-circle">
                <img
                  alt="Image placeholder"
                  :src="
                    post.createdBy.profile
                      ? post.createdBy.profile
                      : require('@/assets/default_profile_picture.png')
                  "
                />
              </span>
              <div class="media-body ml-2 d-lg-block">
                <span
                  class="
                    mb-0
                    text-sm
                    font-weight-bold
                    text-black
                    pointer-cursor
                  "
                  >{{ post.createdBy.name }}</span
                >
              </div>
            </div>
            <hr />
            <label for="Content">Content</label>
            <div class="position-relative">
              <!-- <base-input
                alternative
                placeholder="Content"
                v-model="content"
                inputClasses="input-emoji-pr"
              />-->
              <textarea
                class="form-control"
                rows="3"
                placeholder="Content"
                v-model="content"
              ></textarea>

              <emoji-picker @emoji="appendContent" :search="search">
                <div
                  class="emoji-invoker"
                  slot="emoji-invoker"
                  slot-scope="{ events: { click: clickEvent } }"
                  @click.stop="clickEvent"
                >
                  <svg
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                    />
                  </svg>
                </div>
                <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                  <div
                    class="emoji-picker"
                    :style="{ top: '50px', left: screenWidth - 600 + 'px' }"
                  >
                    <div class="emoji-picker__search">
                      <input type="text" v-model="search" v-focus />
                    </div>
                    <div>
                      <div
                        v-for="(emojiGroup, category) in emojis"
                        :key="category"
                      >
                        <h5>{{ category }}</h5>
                        <div class="emojis">
                          <span
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="insert(emoji)"
                            :title="emojiName"
                            >{{ emoji }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </emoji-picker>
            </div>
            <base-button
              class="mt-4"
              type="primary"
              :loading="isLoading"
              @click="onSaveClicked"
              >Save Change</base-button
            >
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-5" v-if="post">
        <comment-list :id="post.id" />
      </div>
      <div class="cold-md-12">
        <confirmation-modal
          :isLoading="isLoading"
          :showModal.sync="showModal"
          message="Are you sure want to delete this Post?"
          positiveText="Delete"
          negativeText="Cancel"
          @onPositiveClicked="onPositiveClicked"
          @onNegativeClicked="onNegativeClicked"
        />
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import { mapState } from "vuex";

import { GET_POST, DELETE_POST, EDIT_POST } from "@/store/actions.type";

import "video.js/dist/video-js.css";
import VideoPlayer from "@/views/LiveStream/VideoPlayer";
import CommentList from "@/views/NewsFeed/CommentList";
import EmojiPicker from "vue-emoji-picker";

export default {
  components: {
    VideoPlayer,
    CommentList,
    EmojiPicker,
  },
  data() {
    return {
      playerOptions: {
        sources: [{ src: "" }],
        autoplay: true,
        controls: true,
      },
      content: "",
      videoSource: null,
      showModal: false,
      search: "",
      screenWidth: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(GET_POST, to.params.id).then(() => next());
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.content = this.post.content;
    if (this.video) {
      this.playerOptions.sources[0].src =
        this.video.request.files.hls.cdns.akfire_interconnect_quic.url;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth / 1.5;
    },
    onSaveClicked() {
      if (this.content) {
        const post = {
          content: this.content,
          userId: this.post.createdBy.id,
          video: this.post.video,
          image: this.post.image,
        };
        this.$store.dispatch(EDIT_POST, { id: this.post.id, post });
      }
    },
    onDeleteClicked() {
      this.showModal = true;
    },
    onPositiveClicked() {
      this.$store.dispatch(DELETE_POST, this.post.id).then(() => {
        this.showModal = false;
        setTimeout(() => {
          this.$router.push({ path: "/newsfeed" });
        }, 0);
      });
    },
    onNegativeClicked() {
      this.showModal = false;
    },
    appendContent(emoji) {
      this.content += emoji;
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  computed: {
    ...mapState({
      post: (state) => state.newsfeed.post,
      video: (state) => state.newsfeed.video,
      isLoading: (state) => state.newsfeed.isLoading,
    }),
  },
};
</script>
